import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { retry, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { AlertService } from '@app/_services';
import { PropertyProfile } from './property-profile';
import { SharedService } from './../_shared/shared.service';

@Injectable({ providedIn: 'root' })
export class PropertyProfileService {

	realEstateStatuses: any = [
		{ value: '3', name: 'Onboarding-In' },
		{ value: '0', name: 'Active' },
		{ value: '4', name: 'Offboarding-Out' },
		{ value: '2', name: 'Renovating' },
		{ value: '1', name: 'Archived' }
	];

	trnsReasons: any = [
		{ value: 1, name: 'Sale' },
		{ value: 2, name: 'Transfer' },
		{ value: 3, name: 'Self Manage' },
		{ value: 4, name: 'Off Market' },
	];

	maintServiceFreqOptions = [
		{ value: 1, name: 'Infrequent' },
		{ value: 2, name: 'Very Rarely' },
		{ value: 3, name: 'Rarely' },
		{ value: 4, name: 'Occasionally' },
		{ value: 5, name: 'Sometimes' },
		{ value: 6, name: 'Moderately Often' },
		{ value: 7, name: 'Often' },
		{ value: 8, name: 'Very Often' },
		{ value: 9, name: 'Almost Always' },
		{ value: 10, name: 'All the time' },
	];

	taxPaidOptions: any = [
		{ value: 1, name: 'paid by KBM' },
		{ value: 2, name: 'Paid By Owner' },
	];

	constructor
		(
			private http: HttpClient,
			private alertService: AlertService,
			private sharedService: SharedService
		) { }

	urlEndpoint = 'property-profiles';

	add(propertyProfile: PropertyProfile): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(propertyProfile));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, propertyProfile);
	}

	update(propertyProfile: PropertyProfile): Observable<ApiResponse> {
		return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, propertyProfile);
	}

	delete(developmentId: number): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${developmentId}`);
	}

	deletePropertyAndOwnerProfileRelationship(propertyOwnerProfile: any): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/delete-property-owner-relationship`, propertyOwnerProfile);
	}

	findAll(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/find-all`).pipe(retry({ count: 2, delay: 1500 }));
	}

	findAllForRequiredFields(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/find-all-profiles`);
	}

	findByFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse> {
		let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		console.log('posting... ' + JSON.stringify(filters));
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, { params: params });

	}

	findById(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`);
	}

	audit(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}/audit`);
	}

	updateShowResIncomeFlag(propertyProfile: any): Observable<ApiResponse> {
		return this.http.patch<ApiResponse>(`${environment.apiUrl}/property-profiles/show-rez-income`, propertyProfile);
	}


	prepareParamsFromPrimeNgDataTable(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any) {
		try {
			console.log(
				'  |  page:' + page
				+ '  |  size:' + size
				+ '  |  sortBy:' + sortBy
				+ '  |  sortOrder:' + sortOrder
				+ '  |  multiSortMeta:' + JSON.stringify(multiSortMeta)
				+ '  |  globalFilter:' + globalFilter
				+ '  |  filters:' + JSON.stringify(filters)
			);

			let params = new HttpParams();

			if (!isNaN(page)) { params = params.append('page', page); }
			if (!isNaN(size)) { params = params.append('size', size); }
			if (sortBy) { params = params.append('sort', sortBy + ',' + (sortOrder === 1 ? 'asc' : 'desc')); }
			if (multiSortMeta) {
				// if sortMode="multiple" in primeng table then multiSortMeta is used for ALL sorting (even just one column.)
				// Otherwise, single sorting is used above.
				// event.multiSortMeta:[{"field":"lastName","order":1},{"field":"firstName","order":1}]
				for (let i = 0; i < multiSortMeta.length; i++) {
					let json = JSON.parse(JSON.stringify(multiSortMeta[i]));
					params = params.append('sort', json.field + ',' + (json.order === 1 ? 'asc' : 'desc'));
				}
			}
			// globalFilter works, but did not implemnt in Spring but not hard to write custom findAll and specify certain columns to look.
			if (globalFilter) { params = params.append('filter', globalFilter); }

			// multiselect or input or whatever... these work slick.
			if (filters) {
				// key:status val:{"value":["A"],"matchMode":"in"}
				for (let i = 0, keys = Object.keys(filters), ii = keys.length; i < ii; i++) {
					console.log('key:' + keys[i] + ' val:' + JSON.stringify(filters[keys[i]]));
					params = params.append(keys[i], filters[keys[i]].value);
				}
			}
			return params;
		} catch (error) {
			console.log('prepareParamsFromPrimeNgDataTable()' + error);
		}
	}
}
